var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1753(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753",
    transform: "translate(-1727 -593)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1727 593)",
    fill: "#121b45"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cube-view",
    transform: "translate(1717.467 594.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 1.467,
    cy: 1.467,
    r: 1.467,
    transform: "translate(26.066 15.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M59.57,64.018a6.056,6.056,0,0,0-11.406,0L48,64.4l.164.382a6.056,6.056,0,0,0,11.406,0l.164-.382Zm-5.7,3.315A2.933,2.933,0,1,1,56.8,64.4,2.933,2.933,0,0,1,53.867,67.333Z",
    transform: "translate(-26.333 -47.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M36.7,11.231,27.9,6.1a.733.733,0,0,0-.739,0l-8.8,5.133a.733.733,0,0,0-.364.634V22.131a.733.733,0,0,0,.364.634l8.8,5.133a.733.733,0,0,0,.739,0l8.8-5.133a.733.733,0,0,0,.364-.634V11.865A.733.733,0,0,0,36.7,11.231ZM35.6,21.71l-8.066,4.7-8.066-4.7V12.286l8.066-4.7,8.066,4.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1753);
export default __webpack_public_path__ + "static/media/Group 1753.c7f474b7e4fc2555173e2f1c4656b640.svg";
export { ForwardRef as ReactComponent };